export default __webpack_public_path__ + "static/media/border-tip-left.58ee4b4d.png";